<template>
  <q-dialog v-model="visible" persistent>
    <q-card class="container">
      <div class="modal-header">
        <q-card-section class="header">
          <div class="header-content-wrapper">
            <div class="header-title">{{ modalTitle }}</div>
            <q-btn flat round color="white" icon="close" @click="onClose" class="header-close-btn" />
          </div>
        </q-card-section>
      </div>

      <div class="modal-body">
        <div class="content">
          <!-- Container com borda englobando seção superior -->
          <div class="container1">
              <div class="div-inside-container1">
                <!-- Seção superior com ícones -->
                <div class="stats-container">
                  <div class="stat-card">
                    <div class="stat-label">{{ this.$gettext('INDUSTRIAL_MAP_RESIDUE_COLLECTED') }}</div>
                    <TrashIcon />
                    <div class="stat-value">{{ estatisticas.residuosColetados }}</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-label">{{ this.$gettext('INDUSTRIAL_MAP_QTD_COLLECTED') }}</div>
                    <VolumeIcon />
                    <div class="stat-value">{{ estatisticas.qtdColetada }}</div>
                  </div>
                </div>

                <!-- Informações Gerais -->
                <div class="card-hoje">
                  <div class="info-title">{{ this.$gettext('INDUSTRIAL_MAP_GENERAL_INFO') }}</div>
                  <div class="info-grid">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_PREV_INICIO') }}</div>
                      <div class="info-value">{{ informacoesGerais.inicio }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_COLLECTION_END') }}</div>
                      <div class="info-value">{{ informacoesGerais.fim }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_COLLECTION_STATUS') }}</div>
                      <div class="info-value">{{ informacoesGerais.status }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tarefas / Motoristas (Accordion) -->
            <div class="container2">
              <div class="motoristas-section">
              <q-expansion-item
                v-for="(tarefa, index) in tarefasMotoristas"
                :key="index"
                class="motorista-expansion"
                header-class="text-white"
                expand-icon-class="text-white"
              >
                <template v-slot:header>
                  <q-item-section>
                    <div class="motorista-header-content">
                      <span class="motorista-header-text">{{ (index + 1) }}º {{ tarefa.driverName || $gettext('INDUSTRIAL_MAP_DRIVER') }} - {{ tarefa.plate || $gettext('INDUSTRIAL_MAP_PLATE') }} / {{ formatTime(tarefa.scheduledDate) }}</span>
                      <q-icon
                        :name="getTaskStatusIcon(tarefa.collectTaskStatus)"
                        :color="getTaskStatusIconColor(tarefa.collectTaskStatus)"
                        size="20px"
                        class="motorista-status-icon"
                      />
                    </div>
                  </q-item-section>
                </template>

                <q-card>
                  <q-card-section class="tarefa-details">
                    <!-- Informações comuns agrupadas -->
                    <div class="tarefa-info-group">
                      <div class="detail-grid">
                        <div class="detail-row">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_VEICULO') }}</div>
                          <div class="detail-value">{{ tarefa.plate || '-' }}</div>
                        </div>
                        <div class="detail-row">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_COLLECTION_STATUS') }}</div>
                          <div class="detail-value">{{ tarefa.collectTaskStatus || '-' }}</div>
                        </div>
                        <div class="detail-row">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_RESPONSIBLE') }}</div>
                          <div class="detail-value">{{ tarefa.driverName || '-' }}</div>
                        </div>
                        <div class="detail-row">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_PREV_INICIO') }}</div>
                          <div class="detail-value">{{ formatDate(tarefa.scheduledDate) }}</div>
                        </div>
                        <div class="detail-row">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_COLLECTION_END') }}</div>
                          <div class="detail-value">{{ formatDate(tarefa.endDate) }}</div>
                        </div>
                        <div class="detail-row full-width">
                          <div class="detail-label">{{ $gettext('INDUSTRIAL_MAP_OBSERVATION') }}</div>
                          <div class="detail-value">{{ tarefa.route || '-' }}</div>
                        </div>
                      </div>
                    </div>

                    <!-- Lista de resíduos / acondicionamentos -->
                    <div class="residuos-list">
                      <div class="residuos-title">{{ $gettext('INDUSTRIAL_MAP_RESIDUE_COLLECTED') }}</div>
                      <div
                        v-for="(item, iIndex) in tarefa.residuos"
                        :key="iIndex"
                        class="residuo-item"
                      >
                        <div class="residuo-row">
                          <div class="residuo-name">{{ item.productName || 'Resíduo' }}</div>
                          <div class="residuo-quantity">{{ item.quantityTons }}</div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              </div>
            </div>
        </div>
      </div>

      <div class="modal-footer">
        <q-card-actions align="center" class="footer">
          <q-btn :label="$gettext('INDUSTRIAL_MAP_BTN_CLOSE')" color="grey-7" class="btn-fechar" @click="onClose" />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator'
import VolumeIcon from 'src/components/industrialMap/icons/VolumeIcon.vue'
import TrashIcon from 'src/components/industrialMap/icons/TrashIcon.vue'

@Component({
  name: 'ModalDetalhesColeta',
  components: {
    TrashIcon,
    VolumeIcon
  }
})
class ModalDetalhesColeta extends Vue {
  @Prop({ type: Boolean, default: false })
  value

  @Prop({ type: Object, default: () => ({}) })
  coleta

  get visible () {
    return this.value
  }

  set visible (val) {
    this.$emit('input', val)
  }

  get modalTitle () {
    const prefix = this.$gettext('INDUSTRIAL_MAP_COLLECTION_PREFIX')
    const defaultPoint = this.$gettext('INDUSTRIAL_MAP_COLLECTION_POINTS')
    if (this.coleta && this.coleta.collectionPointName) {
      return `${prefix} - ${this.coleta.collectionPointName}`
    }
    if (this.coleta && this.coleta.detalhes && this.coleta.detalhes.dadosForm) {
      const dadosForm = this.coleta.detalhes.dadosForm
      return `${prefix} - ${dadosForm.name || defaultPoint}`
    }
    return `${prefix} - ${defaultPoint}`
  }

  get informacoesGerais () {
    if (this.coleta && this.coleta.detalhes && this.coleta.detalhes.dadosForm) {
      const dadosForm = this.coleta.detalhes.dadosForm
      const tasks = dadosForm.industrialTasks || []

      // First collection (earliest scheduledDate)
      let firstDate = null
      let lastDate = null
      let lastStatus = '-'

      if (tasks.length > 0) {
        const sortedTasks = [...tasks].sort((a, b) => {
          const dateA = a.scheduledDate ? new Date(a.scheduledDate) : new Date(0)
          const dateB = b.scheduledDate ? new Date(b.scheduledDate) : new Date(0)
          return dateA - dateB
        })
        firstDate = sortedTasks[0].scheduledDate
        lastDate = sortedTasks[sortedTasks.length - 1].scheduledDate
        lastStatus = sortedTasks[sortedTasks.length - 1].collectTaskStatus || sortedTasks[sortedTasks.length - 1].status || '-'
      }

      return {
        inicio: this.formatDate(firstDate),
        fim: this.formatDate(lastDate),
        status: lastStatus
      }
    }

    // Fallback using data from the list (findCollections grid)
    return {
      inicio: this.formatDate(this.coleta?.firstScheduledDate),
      fim: this.formatDate(this.coleta?.lastScheduledDate),
      status: '-'
    }
  }

  get tarefasMotoristas () {
    if (this.coleta && this.coleta.detalhes && this.coleta.detalhes.dadosForm) {
      const dadosForm = this.coleta.detalhes.dadosForm
      const tasks = dadosForm.industrialTasks || []

      // Group-level fallback values (from industrialTaskGroup.detalhar)
      const groupDriverName = dadosForm.driverName || null
      const groupPlate = dadosForm.plate || null
      const groupRoute = dadosForm.route || null

      return tasks.map(task => {
        const allItems = task.industrialTaskItems || []
        // Filter only collected items (status = COLETADA)
        const items = allItems.filter(item => {
          if (!item.status) return true
          const s = item.status.toUpperCase()
          return s.includes('COLETADA') || s.includes('COLLECTED') || s.includes('COMPLETA')
        })
        const residuos = items.map(item => {
          let quantityKg = 0
          if (item.industrialCollectionWeighings && item.industrialCollectionWeighings.length > 0) {
            quantityKg = item.industrialCollectionWeighings.reduce((acc, w) => acc + (w.gumpQuantity || 0), 0)
          }
          const quantityTons = (quantityKg / 1000).toFixed(2)
          return {
            productName: item.product || this.$gettext('INDUSTRIAL_MAP_RESIDUE'),
            isCollected: true,
            rawQuantityKg: quantityKg,
            rawQuantityTons: parseFloat(quantityTons),
            quantityTons: `${quantityTons} ${parseFloat(quantityTons) !== 1 ? this.$gettext('INDUSTRIAL_MAP_TONS_PLURAL') : this.$gettext('INDUSTRIAL_MAP_TON_SINGULAR')}`
          }
        })

        return {
          driverName: task.driverName || task.responsibleName || groupDriverName || this.$gettext('INDUSTRIAL_MAP_DRIVER'),
          plate: task.plate || groupPlate || '-',
          scheduledDate: task.scheduledDate,
          endDate: null,
          collectTaskStatus: task.collectTaskStatus || task.status || '-',
          route: task.route || groupRoute || '-',
          residuos: residuos.length > 0 ? residuos : [{ productName: this.$gettext('INDUSTRIAL_MAP_NO_RESIDUE'), isCollected: false, rawQuantityKg: 0, rawQuantityTons: 0, quantityTons: `0 ${this.$gettext('INDUSTRIAL_MAP_TONS_PLURAL')}` }]
        }
      }).sort((a, b) => {
        // Most recent collection first
        if (!a.scheduledDate && !b.scheduledDate) return 0
        if (!a.scheduledDate) return 1
        if (!b.scheduledDate) return -1
        return new Date(b.scheduledDate).getTime() - new Date(a.scheduledDate).getTime()
      })
    }

    return []
  }

  get estatisticas () {
    // Compute totals from accordion data (tarefasMotoristas) to ensure consistency
    const tarefas = this.tarefasMotoristas
    if (tarefas.length > 0) {
      let totalResidues = 0
      let totalWeightKg = 0

      tarefas.forEach(tarefa => {
        tarefa.residuos.forEach(residuo => {
          if (residuo.isCollected) {
            totalResidues++
          }
          const weight = parseFloat(residuo.rawQuantityKg)
          if (!isNaN(weight)) {
            totalWeightKg += weight
          }
        })
      })

      return {
        residuosColetados: totalResidues,
        qtdColetada: `${(totalWeightKg / 1000).toFixed(2)} T`
      }
    }

    // Fallback from backend totals or list data
    if (this.coleta && this.coleta.detalhes && this.coleta.detalhes.dadosForm) {
      const dadosForm = this.coleta.detalhes.dadosForm
      return {
        residuosColetados: dadosForm.totalResidues || 0,
        qtdColetada: `${dadosForm.totalQuantityTons || 0} T`
      }
    }

    return {
      residuosColetados: 0,
      qtdColetada: '0 T'
    }
  }

  getTaskStatusIcon (status) {
    if (!status) return 'mdi-truck-fast-outline'
    const s = status.toUpperCase()
    if (s.includes('CONFIRM') || s.includes('REALIZADA') || s.includes('CONCLU')) return 'mdi-check-circle'
    if (s.includes('PROGRESS') || s.includes('ANDAMENTO')) return 'mdi-truck-fast-outline'
    if (s.includes('CANCEL')) return 'mdi-close-circle'
    return 'mdi-truck-fast-outline'
  }

  getTaskStatusIconColor (status) {
    if (!status) return 'blue-grey'
    const s = status.toUpperCase()
    if (s.includes('CONFIRM') || s.includes('REALIZADA') || s.includes('CONCLU')) return 'green'
    if (s.includes('PROGRESS') || s.includes('ANDAMENTO')) return 'blue'
    if (s.includes('CANCEL')) return 'red'
    return 'blue-grey'
  }

  onClose () {
    this.visible = false
    this.$emit('close')
  }

  formatDate (dateString) {
    if (!dateString) return '00/00/0000 - 00:00'

    try {
      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${day}/${month}/${year} - ${hours}:${minutes}`
    } catch (error) {
      console.error('Erro ao formatar data:', error)
      return '00/00/0000 - 00:00'
    }
  }

  formatTime (dateString) {
    if (!dateString) return '00:00'

    try {
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${hours}:${minutes}`
    } catch (error) {
      return '00:00'
    }
  }
}

export default ModalDetalhesColeta
</script>

<style lang="stylus" scoped>
.container
  width: 920px
  max-width: 920px
  height: 640px
  max-height: 640px
  border-radius: 10px
  padding-top: 16px
  background: white
  display: flex
  flex-direction: column
  gap: 20px
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)

.modal-header
  flex-shrink: 0

.header
  height: 50px
  padding: 8px 20px
  border-radius: 4px
  color: white !important
  flex-shrink: 0
  background-color: #1E4971

.header-content-wrapper
  width: 856px
  height: 34px
  gap: 20px
  display: flex
  align-items: center
  justify-content: space-between
  margin: 0 auto

.header-title
  height: 34px
  font-family: Roboto
  font-weight: 700
  font-style: Bold
  font-size: 28px
  line-height: 34px
  flex-grow: 1

.header-close-btn
  flex-shrink: 0
  cursor: pointer
  margin: 0

.modal-body
  height: 544px
  overflow-y: auto
  padding: 0px 16px 0px 0px

.content
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  padding: 0px 0px 0px 16px
  width: 888px

.modal-footer
  flex-shrink: 0

.footer
  height: 60px
  gap: 20px
  padding: 12px 0
  background: #FFFFFF
  display: flex
  justify-content: center
  align-items: center
  flex-shrink: 0

.container1
  width: 888px
  gap: 20px
  display: flex
  flex-direction: column
  flex-shrink: 0

.container2
  width: 888px
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  overflow-y: auto

.div-inside-container1
  width: 888px
  gap: 16px
  border-width: 1px
  border-radius: 8px
  padding: 16px
  background: #FCFCFC
  border: 1px solid #E0E0E0
  display: flex
  flex-direction: column
  flex-shrink: 0

.stats-container
  display: flex
  gap: 16px
  margin-bottom: 0

.stat-card
  flex: 1
  background: transparent
  border: none
  padding: 0
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  gap: 8px

.stat-label
  font-size: 18px
  font-weight: 500
  color: #757575
  text-align: center

.stat-value
  font-size: 34px
  font-weight: 700
  color: #31CCCB
  text-align: center

.card-hoje
  width: 856px
  gap: 8px
  border-radius: 8px
  padding: 12px
  border-left: 3px solid #0679CC
  background: #FFFFFF
  overflow-y: hidden
  flex-shrink: 0

.info-title
  font-size: 18px
  font-weight: 500
  color: #424242
  margin-bottom: 12px
  padding-bottom: 0
  border-bottom: none

.info-grid
  display: grid
  grid-template-columns: repeat(3, 1fr)
  gap: 8px

.info-row
  display: flex
  background: #f2f2f2
  border-radius: 4px
  padding: 8px 12px
  align-items: center

.info-row.full-width
  grid-column: 1 / -1

.info-label
  font-weight: 500
  color: #0f5295
  min-width: 80px
  margin-right: 8px
  font-size: 14px

.info-value
  color: #424242
  flex: 1
  font-size: 14px

.motoristas-section
  display: flex
  flex-direction: column
  gap: 8px

.motorista-expansion
  background-color: #0F5295
  border-radius: 4px
  margin-bottom: 8px

.motorista-expansion >>> .q-expansion-item__toggle-icon
  color: white !important

.motorista-expansion >>> .q-item__section--side
  color: white !important

.motorista-header-content
  display: flex
  align-items: center
  width: 100%

.motorista-header-text
  color: white
  font-weight: 500
  font-size: 14px

.motorista-status-icon
  margin-left: 6px
  color: white !important

.tarefa-details
  padding: 12px
  background: white

.tarefa-info-group
  margin-bottom: 12px

.residuos-list
  border-top: 1px solid #E0E0E0
  padding-top: 12px

.residuos-title
  font-size: 14px
  font-weight: 600
  color: #0f5295
  margin-bottom: 8px

.residuo-item
  background: #f2f2f2
  border-radius: 4px
  padding: 8px 12px
  margin-bottom: 6px

.residuo-item:last-child
  margin-bottom: 0

.residuo-row
  display: flex
  justify-content: space-between
  align-items: center

.residuo-name
  font-weight: 500
  color: #0f5295
  font-size: 14px

.residuo-quantity
  color: #424242
  font-size: 14px

.detail-grid
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 8px

.detail-row
  display: flex
  background: #f2f2f2
  border-radius: 4px
  padding: 8px 12px
  align-items: center

.detail-row.full-width
  grid-column: 1 / -1

.detail-label
  font-weight: 500
  color: #0f5295
  min-width: 100px
  margin-right: 8px
  font-size: 14px

.detail-value
  color: #424242
  flex: 1
  font-size: 14px

.btn-fechar
  width: 120px
</style>
